module.exports = __webpack_public_path__ + "static/media/stofferingen-39.6989db0a.jpg";